import React from 'react';

export default function StarRating({ rating = 0, reviews }) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;

  return (
    <span className="star-rating" aria-label={`Calificación ${rating} de 5`}>
      {Array.from({ length: 5 }).map((_, i) => {
        let symbol = '☆';
        if (i < full) symbol = '★';
        else if (i === full && hasHalf) symbol = '★';
        return (
          <span key={i} className={i < full || (i === full && hasHalf) ? 'star filled' : 'star'}>
            {symbol}
          </span>
        );
      })}
      <span className="rating-number">{rating.toFixed(1)}</span>
      {reviews !== undefined && <span className="rating-reviews">({reviews} reseñas)</span>}
    </span>
  );
}
